import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=35ff536f&scoped=true&"
import script from "./BalanceDetail.vue?vue&type=script&lang=js&"
export * from "./BalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDetail.vue?vue&type=style&index=0&id=35ff536f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff536f",
  null
  
)

export default component.exports